import { RootStateOrAny } from 'react-redux';
import { _ } from '~/dependencies';

export type Agent = {
  extension_is_used: number;
  name: string;
  number: number;
  status: string;
  subscription: string;
};

export type AgentState = {
  favorite?: boolean;
  loading?: boolean;
  addFavoriteAgent(extension: number): void;
};

export type Agents = Agent[];

export type AgentActionsProps = {
  agent: Agent;
} & AgentState;

export const filterFavoriteExtensions = ({
  phone: { extensions, favoriteAgents, sipCredentials },
}: RootStateOrAny) => {
  if (!sipCredentials?.extension) return [];
  const { extension } = sipCredentials;

  const favoriteSet = new Set(favoriteAgents.map(String));

  const favorites = _.filter(
    extensions,
    (ext: Agent) =>
      favoriteSet.has(String(ext.number)) &&
      String(ext.number) !== String(extension)
  );
  return _.orderBy(favorites, ['number'], ['asc']);
};

export const filterUnfavoriteExtensions = ({
  phone: { extensions, favoriteAgents, sipCredentials },
}: RootStateOrAny) => {
  if (!sipCredentials?.extension) return [];
  const { extension } = sipCredentials;

  const favoriteSet = new Set(favoriteAgents.map(String));

  const unfavorites = _.filter(
    extensions,
    (ext: Agent) =>
      !favoriteSet.has(String(ext.number)) &&
      String(ext.number) !== String(extension)
  );
  return _.orderBy(unfavorites, ['number'], ['asc']);
};

export function searchIn(extensions: Agents = [], searchFor: string) {
  return extensions.length && searchFor
    ? extensions.filter(
        (ext: Agent) =>
          String(ext.number).startsWith(searchFor) ||
          ext?.name.toUpperCase().includes(String(searchFor.toUpperCase()))
      )
    : extensions;
}
